import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import Spinner from "../../Components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
const EditPickupRequestComponent = loadable(
  () => import("../../Components/InternationalPickupRequest/SwitchTab")
);
const EditPickupRequest = () => {
  const { id } = useParams();
  const [defaultValue, setDefaultValue] = useState(null);
  const [openAddVehiclePopup, setOpenAddVehiclePopup] = useState(false);
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`pickup-request-${id}`],
    url: `${APIS.PICKUPREQUEST}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`pickup-request-${id}`, "pickup-request"],
    navigateURL: "",
  });
  const { data: gridData, isLoading: isStatusDataLoading } = useGetHook({
    queryKey: [`runsheet-status`],
    url: `${APIS.PICKUPREQUEST_STATUS}`,
    params: {},
  });

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } =
    usePatchHook({
      queryKey: [`pickup-request-${id}`, "pickup-request"],
      navigateURL: "",
    });
  const { mutateAsync: addVehicle, isPostLoading: isVehicleLoading } =
    usePostHook({
      queryKey: ["vehicle"],
      navigateURL: "",
    });
  const { mutateAsync: addDriver, isPostLoading: isDriverLoading } =
    usePostHook({
      queryKey: ["riders"],
      navigateURL: "",
    });

  const handleAddDriver = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER_CREATE}`;
    let formData = {
      ...values,
    };
    try {
      const res = await addDriver({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddDriverPopup(!openAddDriverPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleAddVehicle = async (values: any, setError: any) => {
    const url = `${APIS.VEHICLE}`;
    let formData = {
      ...values,
      insurance_company_contact_number: values?.insurance_company_contact_number
        ? values?.insurance_company_contact_number.startsWith("+977")
          ? values?.insurance_company_contact_number
          : `+977${values?.insurance_company_contact_number}`
        : null,
      samiti_contact_number: values?.samiti_contact_number
        ? values?.samiti_contact_number.startsWith("+977")
          ? values?.samiti_contact_number
          : `+977${values?.samiti_contact_number}`
        : null,
    };
    try {
      const res = await addVehicle({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAddVehiclePopup(!openAddVehiclePopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.PICKUPREQUEST}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-pickup-request-items"],
  });

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.PICKUPREQUEST}${id}/`;
    let formData = {
      is_active: false,
    };
    try {
      await toggleMarkAsDone({ url, formData, setError });
      await refetch();
    } catch (err) {
      console.log(err);
    }
  };

  const handlecheckConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.PICKUPREQUEST}receive-order/`;
    let formData = {
      tracking_number: consignmentId,
    };
    try {
      await checkConsignmentsMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  // const handleAttachConsignment = async (
  //   consignmentId: string,
  //   setError: any
  // ) => {
  //   const url = `${APIS.PICKUPREQUEST_ITEMS}`;
  //   let formData = {
  //     pickup_request: id,
  //     orders: [consignmentId],
  //   };
  //   try {
  //     await attachConsignmentMutateAsync({ url, formData, setError });
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Assign Pickup Request
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditPickupRequestComponent
          isLoading={isPatchLoading}
          data={data}
          handleUpdate={handleEdit}
          gridData={gridData}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handlecheckConsignments={handlecheckConsignments}
          handleToggleMarkAsDone={handleToggleMarkAsDone}
          handleAddVehicle={handleAddVehicle}
          isVehicleLoading={isVehicleLoading}
          handleAddDriver={handleAddDriver}
          isDriverLoading={isDriverLoading}
          id={id}
          openAddVehiclePopup={openAddVehiclePopup}
          setOpenAddVehiclePopup={setOpenAddVehiclePopup}
          openAddDriverPopup={openAddDriverPopup}
          setOpenAddDriverPopup={setOpenAddDriverPopup}
          // handleAttachConsignment={handleAttachConsignment}
        />
      )}
    </div>
  );
};

export default EditPickupRequest;
